module.exports = __webpack_public_path__ + "img/m-bottom1.0.1.0_202608111507.png";